import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { MatSelectionListChange } from '@angular/material/list';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { optionContainsTerm } from '../../utils/util';

@Component({
    selector: 'desk',
    templateUrl: './desk.html',
    styleUrls: ['./desk.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-desk'
    }
})

export class Desk extends EnpsControl<Array<string>> {

    @Input() itemList: { id: string, title: string, selectable: boolean, initials?: string }[] = [];
    deskFilter = new FormControl('');
    filteredOptions: Observable<{ id: string, title: string, selectable: boolean, initials?: string }[]>;

    get extraDesksCount(): number {
        return this.value.length - 4;
    }

    get shouldShowExtraDesks(): boolean {
        return this.value.length > 5;
    }

    public getItemLabel(item: any) {
        const existingItem = this.itemList.find(option => (option.id?.toLowerCase().includes(item?.toLowerCase())))?.title;
        if (existingItem) return existingItem;
        return item;
    }

    public getItemInitials(item: any) {
        return this.itemList.find(option => (option.id?.toLowerCase().includes(item?.toLowerCase())))?.initials;
    }

    internalValueChanged(event: MatSelectionListChange) {
        this.value = event.source.selectedOptions.selected.map((item) => item.value);
    }

    valueChanged() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this.changed.emit(this.value);
        }
        this.deskFilter.setValue('');
    }


    private _filter(value: string): { id: string, title: string, selectable: boolean, initials?: string }[] {

        return this.itemList.filter(option =>
            optionContainsTerm(option.id, value) || optionContainsTerm(option.title, value));
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();
        const data = this.itemList.find(option => {
            if (value) {
                let filteredOption = optionContainsTerm(option.id, value) || optionContainsTerm(option.title, value)
                return filteredOption;
            }
        })
        if (data) {
            this.value.push(data.id);
        }
        this.isValueChanged = true;
        event.chipInput!.clear();

        this.deskFilter.setValue('');
    }

    remove(item: string): void {
        const index = this.value.indexOf(item);

        if (index >= 0) {
            this.value.splice(index, 1);
        }
        this.isValueChanged = true;
    }

    selected(event: MatSelectionListChange): void {
        const selectedGroup = this.value.find(option => option === event.options[0].value)
        if (selectedGroup) return;
        this.value.push(event.options[0].value);
        this.searchBox.nativeElement.value = '';
        this.deskFilter.setValue('');
        this.isValueChanged = true;
    }

    public onMenuOpened(): void {
        super.onMenuOpened();
        this.filteredOptions = this.deskFilter.valueChanges.pipe(
            startWith(''),
            takeUntil(this.destroyed$),
            map(value => this._filter(value || '')),
        );
    }
}
